import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { sectionHook } from '../../lib/domHooks';

/**
 * Merit şemasının bölüm kabuğu: sol üstte başlık (varsa "tümünü gör" oku),
 * sağ üstte şeridi kaydıran ok çifti, altında yatay kayan kart şeridi.
 */
const MeritSection = ({ title, to, wide = false, section, children }) => {
  const stripRef = useRef(null);

  const scroll = (direction) => {
    const el = stripRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * Math.max(el.clientWidth * 0.8, 240), behavior: 'smooth' });
  };

  return (
    <section {...sectionHook(section)}>
      <div className="merit-section-head">
        <h2 className="merit-section-title">
          {title}
          {to && (
            <Link to={to} className="merit-section-more" aria-label={`${title} — tümünü gör`}>
              <ArrowUpRight size={13} />
            </Link>
          )}
        </h2>
        <div className="merit-section-nav">
          <button
            type="button"
            className="merit-subnav-arrow"
            onClick={() => scroll(-1)}
            aria-label="Önceki"
          >
            <ChevronLeft size={14} />
          </button>
          <button
            type="button"
            className="merit-subnav-arrow"
            onClick={() => scroll(1)}
            aria-label="Sonraki"
          >
            <ChevronRight size={14} />
          </button>
        </div>
      </div>
      <div className={`merit-strip ${wide ? 'is-wide' : ''}`} ref={stripRef}>
        {children}
      </div>
    </section>
  );
};

export default MeritSection;
